import React from 'react'
import { Icon as MaleIcon } from '@enamelai/design-system/icons/Male'
import { Icon as FemaleIcon } from '@enamelai/design-system/icons/Female'

function ProfileGenderIcon({
  gender,
}: {
  gender?: string | null
}): React.ReactElement | null {
  if (gender === 'Male') {
    return <MaleIcon className="patient-profile-icon" aria-label="Male" />
  }
  if (gender === 'Female') {
    return <FemaleIcon className="patient-profile-icon" aria-label="Female" />
  }
  return null
}

export default ProfileGenderIcon
